import { prepHandleEvent } from "./prepHandleEvent";
import { EventToCanvas } from "./EventToCanvas";

export function handleMouseMove(canvas) {
  return function (event) {
    var rect = canvas.getBoundingClientRect();
    var p = EventToCanvas(event, rect.left, rect.top);

    var myApp = prepHandleEvent(this, true, p.x, p.y);
    if (myApp == null) return;

    myApp.HandleMouseMove(p.x, p.y);
    event.preventDefault();
  };
}
